import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
    mode  : "history",
    routes: [
        {path: '/', redirect: {name: 'clients.list'}},
        {
            path     : '/login',
            name     : 'login',
            component: require('../pages/LoginPage').default,
            meta     : {auth: false},
        },

        {
            path     : '/dashboard',
            meta     : {auth: true},
            component: require('../components/DashboardLayout').default,
            children : [
                {
                    path     : '/clients',
                    name     : 'clients.list',
                    component: require('../pages/ClientsPage').default,
                },
                {
                    path     : '/clients/add',
                    name     : 'clients.add',
                    component: require('../pages/ClientAddPage').default,
                },
                {
                    path     : '/clients/:clientId',
                    name     : 'clients.show',
                    component: require('../pages/ClientShowPage').default,
                    props    : true,
                },

                {
                    path     : '/card-types',
                    name     : 'card-types.list',
                    component: require('../pages/CardTypesPage').default,
                },
                {
                    path     : '/card-types/:cardTypeId/edit',
                    name     : 'card-types.edit',
                    component: require('../pages/CardTypeEditPage').default,
                    props    : true,
                },

                {
                    path     : '/messages',
                    name     : 'messages.list',
                    component: require('../pages/MessagesPage').default,
                    props    : (route) => ({page: route.query.page ? parseInt(route.query.page) : 1}),
                },

                {
                    path     : '/stats',
                    name     : 'stats',
                    component: require('../pages/StatsPage').default,
                },

                {
                    path     : '/settings',
                    name     : 'settings',
                    component: require('../pages/SettingsPage').default,
                },
                {
                    path     : '/cards',
                    name     : 'cards.list',
                    component: require('../pages/CardsPage').default,
                    props    : (route) => ({period: route.query.period, page: route.query.page ? parseInt(route.query.page) : 1}),
                },
            ]
        },

        {
            path    : "*",
            redirect: {name: 'clients.list'}
        }
    ],
    scrollBehavior() {
        return {x: 0, y: 0};
    }
});

export default router;
